export default __webpack_public_path__ + "static/media/video-forward.939ffd39.svg";